export default function TextareaChecklist(props) {
    return(
        <>
            <h6 className="text-primary">
                {props.label}
            </h6>
            <textarea className="w-100 border border-primary rounded p-2" value={props.value} disabled={true} maxLength={props.maxLength} rows={props.lines} required={props.required}></textarea>
        </>
    )
}